import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessageWrappedInSpan } from '../../misc';

const StillProcessingImagesInfo = ({ onBuyFotoFlat }) => {
  return (
      <div className="processing-images-info mt-20 mb-40">
        <div className="processing-images-info_texts">
          <h1>
            <FormattedMessageWrappedInSpan
              id="stillProcessingImagesInfo.heading"
              defaultMessage="We are still processing - More images might come!"
            />
          </h1>
          <div className="processing-images-info_progress-bar">
            <div className="progress-bar_root">
              <div className="progress-bar_bar" style={{ width: '90%' }}>
                <div class="animated-dot"></div>
              </div>
            </div>
          </div>
          <FormattedMessageWrappedInSpan
            id="stillProcessingImagesInfo.message"
            defaultMessage="<b>Buy now</b> - if we find more, you will get them automatically and <b>for free</b>"
            values={{
              b: (chunks) => <b>{chunks}</b>,
            }}
          />
        </div>
        <div className="processing-images-info_actions">
          {/* WAITING FOR BACKEND CHANGES 
          <button className="btn btn-default info-btn  full-width">
            <FormattedMessageWrappedInSpan
              id="stillProcessingImagesInfo.actions.cancel"
              defaultMessage="Notify to buy when processed"
            />
          </button> */}
          <button
            onClick={() => onBuyFotoFlat()}
            className="btn btn-default info-btn main-action full-width"
          >
            <FormattedMessageWrappedInSpan
              id="stillProcessingImagesInfo.actions.buyNow"
              defaultMessage="Buy now"
            />
          </button>
        </div>
      </div>
  );
};

StillProcessingImagesInfo.propTypes = {
  onBuyFotoFlat: PropTypes.func,
};

export default StillProcessingImagesInfo;
